import { useOktaAuth } from "@okta/okta-react";
import { useEffect, useState } from "react";
import { Department, DepartmentResponse } from "../services/coworkerApiCalls/Department/DepartmentsTypes";
import { getDepartmentById, getDepartments, getSpacesByDepartementId } from "../services/coworkerApiCalls/Department/Department";
import { serviceResponsesToServices, serviceResponseToService } from "../services/helpers/DepartmentMapper";
import { Space } from "../services/coworkerApiCalls/Space/SpacesTypes";
import { spaceResponsesToSpaces } from "../services/helpers/SpaceMapper";

function useDataApiServices() {
    const [service, setService] = useState<Department[]>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getService = async () => {

            const servicesTemporary: Department[] = await getDepartments(token);
            const servicesResult: DepartmentResponse[] = serviceResponsesToServices(servicesTemporary);
            setService(servicesResult);

        };
        void getService();

    }, [token]); // Or [] if effect doesn't need props or state


    return service;
}


// To have all lines of a specific service in quota table

function useDataApiSpacesByServiceId(serviceId : number) {
    const [service, setService] = useState<Space[]>();
    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getService = async () => {
            const servicesTemporary = await getSpacesByDepartementId(token, serviceId);
            const servicesResult = spaceResponsesToSpaces(servicesTemporary);
            setService(servicesResult);

        };
        void getService();

    }, [token,serviceId]); // Or [] if effect doesn't need props or state


    return service;
}


function useDataApiDepartmentById(id: number) {
    const [space, setSpace] = useState<Department>();

    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {

            const departmentTemporary: Department = await getDepartmentById(token, id);
            const departmentResult: DepartmentResponse = serviceResponseToService(departmentTemporary);
            setSpace(departmentResult);

        };
        void getUsers();

    }, [id, token]); // Or [] if effect doesn't need props or state
    
    return space;
}



export { useDataApiServices, useDataApiSpacesByServiceId, useDataApiDepartmentById}